// extracted by mini-css-extract-plugin
export default {"apply_form":"admin_apply_form__FP9Ij","stat_table":"admin_stat_table__-qrou"};